/**
 * @author Gananath Athukorala
 * @version 0.1
 * @since 6/23/2023
 */
import React, { useState } from "react";
import DeleteModal from "../../../components/DeleteModals/DeleteModal";
import EditOrgsModal from "./EditOrgsModal";
import { useNavigate } from "react-router-dom";
import ApkUploadModal from "../../application/components/ApkUploadModal";
import { RequestErrorHandeling } from "../../../../base/errorHandeling/RequestErrorHandeling";
import api from "../../../../base/services/ResApi";
import ApproveCardItem from "./ApproveCardItem";
import ApproveOrgMoreInfoModal from "./ApproveOrgMoreInfoModal";

const ApprovedOrgsItem = (props) => {
  const [deleteModalOpen, setDeleteModalopen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const [moreInfoModalOpen, setMoreInfoModalOpen] = useState(false);
  const [orgLogo, setOrgLogo] = useState()

  const [isBtnLoading, setIsBtnLoading] = useState(false);

  // Delete modal api
  const handleDelete = () => {
    setIsBtnLoading(true);
    const delConfig = {
      headers: { "Org-Code": props.orgData.orgCode },
    };

    api
      .delete("/organizations", delConfig)
      .then((res) => {
        setDeleteModalopen(false);
        props.setIsSuccess(true);
        props.setSuccessMessages([res.data?.description]);
        props.setErrorMessages([]);
        props.setIserror(false);
       props.setUpdateData(true)
       setIsBtnLoading(false)
      })
      .catch((error) => {
        setIsBtnLoading(false);
        setDeleteModalopen(false);
        RequestErrorHandeling(
          error,
          props.setIserror,
          props.setErrorMessages,
          props.setIserrorShow,
          props.setIsUnauhtError
        );
        setTimeout(() => {
          props.setIsSuccess(false)
          props.setSuccessMessages([]);
          props.setErrorMessages([]);
          props.setIserror(false);
        }, 3000);
      });
  };

  // To View Group
  const navigate = useNavigate();
  const handleNavigate = (orgCode) => {
    let payload = {
      orgCode: orgCode,
    };
    navigate("../../app/groups", { state: payload });
  };

  return (
    <div style={{ minWidth: 0, height: "100%" }}>
      <ApproveCardItem
        orgCode={props.orgData.orgCode}
        orgName={props.orgData.orgName}
        primAddress={props.orgData.primAddress}
        secAddress={props.orgData.secAddress}
        secContact={props.orgData.secContact}
        primContact={props.orgData.primContact}
        email={props.orgData.email}
        grpTmnlSummary={props.orgData.grpTmnlSummary}
        setDeleteModalopen={setDeleteModalopen}
        setEditModalOpen={setEditModalOpen}
        setMoreInfoModalOpen={setMoreInfoModalOpen}
        handleNavigate={handleNavigate}
        setUploadModalOpen={setUploadModalOpen}
        orgLogo={orgLogo}
        setOrgLogo={setOrgLogo}
      />
      <DeleteModal
        open={deleteModalOpen}
        onClose={() => setDeleteModalopen(false)}
        onDelete={handleDelete}
        isBtnLoading={isBtnLoading}
      />
      <EditOrgsModal
        open={editModalOpen}
        existingCode={props.orgData.orgCode}
        onClose={() => setEditModalOpen(false)}
        roleData={{
          orgName: props.orgData.orgName,
          orgCode: props.orgData.orgCode,
          primAddress: props.orgData.primAddress,
          secAddress: props.orgData.secAddress,
          email: props.orgData.email,
          primContact: props.orgData.primContact,
          secContact: props.orgData.secContact,
          description: props.orgData.description,
        }}
        setUpdateData={props.setUpdateData}
        orgLogo={orgLogo}
      />
      <ApkUploadModal
        open={uploadModalOpen}
        onClose={() => setUploadModalOpen(false)}
        orgName={props.orgData.orgName}
        orgCode={props.orgData.orgCode}
        defaultTab="Upload"
        fromGroup={false}
      />
      <ApproveOrgMoreInfoModal
        open={moreInfoModalOpen}
        onClose={() => setMoreInfoModalOpen(false)}
        orgData={props.orgData}
        orgLogo={orgLogo}
      />
    </div>
  )
};
export default ApprovedOrgsItem;
